module.exports = __webpack_public_path__ + "0bb7b58a4181b2eee5f20fc1f7498a00.jpg";